module.exports = __webpack_public_path__ + "img/palabras2silabas.f60e85b4.png";